import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GenerateMenuSelectionRequest,
  GenerateMenuSelectionRequestResponse,
} from "../../models/MenuSelection.model";

const API_BASE_URL = environment.apiUrl;

export const generateMenuSelectionRequest = createAsyncThunk<
  GenerateMenuSelectionRequestResponse,
  GenerateMenuSelectionRequest,
  { rejectValue: string }
>(
  "menuSelection/generateMenuSelectionRequest",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}ProjectMenu/GenerateMenuSelectionRequest`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GenerateMenuSelectionRequestResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to generate menu selection request");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error"
      );
    }
  }
);